<div class="front-detail-modal">
    <div class="close-modal" (click)="activeModal.close('')">
        <img
            appImageSelector
            alt="mt-image"
            imageType="icon"
            imageKey="x-modal"
        />
    </div>
    <div class="information" *ngIf="machineStatus">
        <div class="status-image">
            <img
                appImageSelector
                alt="mt-image"
                [imageType]="'dashboard-' + machineStatus.machineType"
                [imageKey]="
                    machineStatus.statusImage
                        ? machineStatus.statusImage
                        : 'default'
                "
                (error)="handleImageError($event)"
            />
        </div>
        <div class="model-identifier">
            <span>{{ machineStatus.machineName }}</span> - {{ "model" | lang }}
            <span>{{ machineStatus.machineModelName }}</span>
        </div>
        <div class="shift-information">{{ shiftInformation }}</div>
    </div>

    <div class="mat-tabs">
        <mat-tab-group (selectedTabChange)="changeTab($event)">
            <mat-tab [label]="'summary team' | lang">
                <app-summary-team [summary]="machineStatus"></app-summary-team>
            </mat-tab>

            <mat-tab
                *ngIf="!hideTab && showActionTabsValidator"
                [label]="'change status' | lang"
            >
                <app-change-status
                    [status]="machineStatus"
                    (updateStatusMachine)="onUpdateStatusMachine($event)"
                ></app-change-status>
            </mat-tab>

            <mat-tab
                *ngIf="!hideTab && showActionTabsValidator"
                [label]="'change park' | lang"
            >
                <app-change-park
                    [machineSelected]="machineStatus"
                ></app-change-park>
            </mat-tab>

            <mat-tab [label]="'features team' | lang">
                <app-team-feature [feature]="machineStatus"></app-team-feature>
            </mat-tab>

            <mat-tab *ngIf="isHcm" [label]="'change ubication' | lang">
                <app-change-ubication
                    [ubication]="machineStatus"
                ></app-change-ubication>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
